import React from "react";
import { ASSETS } from "../lib/assets";

/**
 * Stylized Amstrad GX4000 cartridge — black shell with the SEKAI TENSEI label
 * inset on the front. Uses the existing label artwork (luwfg4vr_Sekai-Tensei-Label.png),
 * focusing on the lower portion (skull-nebula art + game title).
 */
export const CartridgeGX4000 = ({ className = "" }) => {
  return (
    <div
      data-testid="cartridge-image"
      className={`relative ${className}`}
      aria-label="Sekai Tensei cartridge — Amstrad GX4000"
    >
      {/* Outer shell */}
      <div
        className="relative w-full"
        style={{
          aspectRatio: "3 / 4",
          background:
            "linear-gradient(180deg, #1a1a1a 0%, #0a0a0a 60%, #050505 100%)",
          borderRadius: "10px 10px 22px 22px",
          boxShadow:
            "inset 0 2px 0 rgba(255,255,255,0.06), inset 0 -10px 30px rgba(0,0,0,0.7), 0 18px 40px rgba(0,0,0,0.6), 0 0 60px rgba(0,255,255,0.08)",
          border: "1px solid #2a2a2a",
        }}
      >
        {/* Top connector ridges */}
        <div
          className="absolute left-1/2 -translate-x-1/2 -top-3 w-[78%] h-5 rounded-t-[6px]"
          style={{
            background:
              "repeating-linear-gradient(90deg, #1a1a1a 0 6px, #0a0a0a 6px 10px)",
            boxShadow: "inset 0 -3px 6px rgba(0,0,0,0.8)",
            border: "1px solid #2a2a2a",
            borderBottom: "none",
          }}
        />
        {/* Top label band — "AMSTRAD GX4000" */}
        <div
          className="absolute top-2 left-1/2 -translate-x-1/2 px-3 py-0.5 font-pixel tracking-widest text-[10px] sm:text-xs text-[#ff0044]"
          style={{
            background: "linear-gradient(180deg,#0a0a0a,#000)",
            border: "1px solid #2a2a2a",
            letterSpacing: "0.25em",
          }}
        >
          ▲ AMSTRAD GX4000
        </div>

        {/* Front label inset */}
        <div
          className="absolute"
          style={{
            top: "12%",
            left: "8%",
            right: "8%",
            bottom: "12%",
            background: "#000",
            border: "1px solid #2a2a2a",
            boxShadow:
              "inset 0 0 0 2px #0a0a0a, inset 0 0 24px rgba(0,255,255,0.08), 0 6px 18px rgba(0,0,0,0.5)",
            overflow: "hidden",
          }}
        >
          {/* Use lower portion (skull-nebula + SEKAI TENSEI) of the original label */}
          <img
            src={ASSETS.cartridgeLabel}
            alt="Sekai Tensei label"
            className="absolute pixelated"
            style={{
              left: "0",
              right: "0",
              bottom: "0",
              width: "100%",
              // Crop the upside-down credits at the top by shifting up
              transform: "translateY(-2%)",
              objectFit: "cover",
            }}
          />
          {/* Glossy reflection */}
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              background:
                "linear-gradient(120deg, rgba(255,255,255,0.10) 0%, rgba(255,255,255,0) 30%, rgba(255,255,255,0) 70%, rgba(255,255,255,0.05) 100%)",
            }}
          />
          {/* Scanlines */}
          <div
            className="absolute inset-0 pointer-events-none mix-blend-multiply opacity-50"
            style={{
              backgroundImage:
                "linear-gradient(rgba(0,0,0,0.18) 50%, transparent 50%)",
              backgroundSize: "100% 3px",
            }}
          />
        </div>

        {/* Bottom curved grip */}
        <div
          className="absolute left-0 right-0 bottom-0 h-[10%]"
          style={{
            background:
              "linear-gradient(180deg, #1a1a1a 0%, #050505 100%)",
            borderTop: "1px solid #2a2a2a",
            borderRadius: "0 0 22px 22px",
          }}
        />
        {/* Bottom side rails */}
        <div
          className="absolute left-2 right-2 bottom-1 h-1 rounded"
          style={{ background: "#1a1a1a", boxShadow: "inset 0 1px 0 rgba(255,255,255,0.05)" }}
        />
      </div>
    </div>
  );
};

export default CartridgeGX4000;
